<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><a id="dedication"></a>To Leslie Thomas, who said it wasn’t easy.<br/>And to Diana, with love.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7165bd42